import { TFunction } from "i18next";

import { BookingConflictErrorType } from "@ryde/shared";

export const ineligibleErrors = [
  BookingConflictErrorType.passengerIneligible,
  BookingConflictErrorType.passengerTimeIneligible,
  BookingConflictErrorType.passengerLocationIneligible,
];

export const resolveBookingIneligibleErrors = (
  serverErrors: string[] | undefined,
  t: TFunction<"translation", undefined>,
): string[] | undefined => {
  if (!serverErrors?.length) {
    return undefined;
  }

  return serverErrors.map(error =>
    ineligibleErrors.includes(error as BookingConflictErrorType)
      ? t(`booking.bulk.${error}`)
      : error,
  );
};
